module.exports = __webpack_public_path__ + "static/media/YF02_0.c82ff713.jpg";